import api from './api';

export const chatService = {
  async sendMessage(sessionId, message) {
    // Use blob responseType to handle both JSON and PDF responses
    const response = await api.post('/chat', {
      session_id: sessionId,
      message: message
    }, {
      responseType: 'blob' // Handle both JSON and PDF
    });
    
    // Check Content-Type header
    const contentType = response.headers?.['content-type'] || 
                       response.headers?.['Content-Type'] || 
                       '';
    
    // If PDF, store blob URL for download (don't auto-download)
    if (contentType && contentType.toLowerCase().includes('application/pdf')) {
      const blob = response.data;
      const blobUrl = window.URL.createObjectURL(blob);
      
      return {
        pdf_available: true,
        pdf_blob_url: blobUrl,
        pdf_filename: `maestro-plan-${sessionId.substring(0, 8)}.pdf`,
        response: 'Your campaign plan PDF is ready! Click the PDF icon to download.'
      };
    }
    
    // Otherwise, parse JSON from blob text
    try {
      const text = await response.data.text();
      const parsed = JSON.parse(text);
      return parsed;
    } catch (error) {
      console.error('Error parsing JSON from blob:', error);
      throw error;
    }
  },

  async createSession(userId = null) {
    const response = await api.post('/create-session', {
      user_id: userId
    });
    return response.data;
  },

  async getThreads(userId = null) {
    const params = userId ? { user_id: userId } : {};
    const response = await api.get('/threads', { params });
    return response.data;
  },

  async getSession(sessionId) {
    const response = await api.get(`/session/${sessionId}`);
    return response.data;
  },

  async exportToPDF(sessionId, title = null) {
    // Get PDF as blob
    const params = title ? { title } : {};
    const response = await api.get(`/export/pdf/${sessionId}`, {
      params,
      responseType: 'blob' // Important: request as blob for binary data
    });
    
    // Create download link
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `maestro-plan-${sessionId.substring(0, 8)}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
    return { success: true };
  }
};

